import fetch from "../fetch";

export default ({ dealCode }) =>
  fetch({
    path: `/clo/deals/${dealCode}/ratings`
  });
